import React from 'react';
import _ from 'lodash';

import C from '../C';
import DataStore, {getPath} from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import PropControl from '../base/components/PropControl';
// import ChartWidget from './ChartWidget';
import { PubTrafficReport } from './PubTrafficReport';
import ShareWidget, { canRead, AccessDenied, ClaimButton } from '../base/components/ShareWidget';
import Misc from '../base/components/Misc';
//Bits stolen from PublisherPage
import CharityControls from './CharityControls';
import Roles from '../base/Roles';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';


function PubDashPage() {
	let path = DataStore.getValue(['location', 'path']);
	let pubId = path[1];
	let pvPublisher = pubId? ActionMan.getDataItem({type:C.TYPES.Publisher, id:pubId, status:C.KStatus.DRAFT, swallow: true}) : null;
	let pub = pvPublisher && pvPublisher.value;

	//special page if user navigates directly to route /#pubdash/ (no args)
	if (!pubId) {
		return <div>
			<h1>You're not supposed to be here</h1>
			<p>Please ensure that the URL you have entered is correct. These should follow the format good-loop.com/#pubdash/www.yourwebsite.com</p>
		</div>;
	}

	// Access?
	let pvCanRead = canRead(C.TYPES.Publisher, pubId);
	
	// let pvCanRead = {resolved: true, value:true}; // TODO
	if (!pvCanRead.resolved) {
		pvCanRead.promise.then(() => DataStore.update());
		return <Misc.Loading text="Checking access" />;
	}
	// access or admin
	if (!pvCanRead.value) {
		return <div><AccessDenied thingId={pubId} /><ClaimButton type={C.TYPES.Publisher} id={pubId} /></div>;
	}
	
	// display...
	let item = ActionMan.getDataItem({type:C.TYPES.Publisher, id:pubId, status:C.KStatus.PUBLISHED}).value;
	return (
		<div className="page PubDashPage">
			<div className="PubTrafficReport">
				<PubTrafficReport q={pubId} />
				<PubSettings entity={pub} item={item} />
			</div>
		</div>
	);
} // ./DashboardPage


function PubSettings({entity, item}) {
	if (!entity) return null;
	// dev only for now
	if (!Roles.isDev()) return null;

	const type = C.TYPES.Publisher;
	const path = getPath(C.KStatus.DRAFT, type, entity.id);

	return (
		<div className="pub-settings">
			<Misc.CardAccordion>
				<Misc.Card title="Settings">
					<Misc.Card title="Manage access">
						Allow other users access this page <br />
						<ShareWidget item={item} hasButton/>
					</Misc.Card>
					<CharityControls entity={entity} />
					<PaymentDetails pub={entity} path={path} />
					<SavePublishDeleteEtc type={C.TYPES.Publisher} id={entity.id} hidden autoPublish autoSave />
				</Misc.Card>
			</Misc.CardAccordion>
		</div>
	);
}

/* Simplified version of PublisherPage's PaymentDetails - see also PaymentSettings.java*/
function PaymentDetails({path, pub, ...stuff}) {
	const payment = pub.payment || {};
	const bank = payment.bank;
	const bpath = path.concat(['payment', 'bank']);
	const approved = payment.approved;

	// NB: text editors for sort-code to allow -s and for account number to keep leading 0s
	return (
		<Misc.Card title="Payment Details" {...stuff} >
			<p>Please provide your bank details so we can pay your earnings to you.</p>
			<PropControl item={bank} path={bpath} prop="accountNumber" label="Bank account number" type="text" />
			<PropControl item={bank} path={bpath} prop="sortCode" label="Sort code" type="text" />
			<div>{approved? "Payments are Approved" : (bank && bank.accountNumber? "Your setup needs approval before payments can be made. Please contact us for more information." : null)}</div>
		</Misc.Card>
	);
}

export default PubDashPage;
